var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.67664,9.66425a2.88018,2.88018,0,0,1-.48224,1.65924,5.62745,5.62745,0,0,1-1.333,1.29065,2.146,2.146,0,0,0-.709.69482,2.59316,2.59316,0,0,0-.21282,1.191H10.93964a4.46755,4.46755,0,0,1,.25567-1.758,3.53479,3.53479,0,0,1,1.29-1.34729,2.52815,2.52815,0,0,0,.681-.72308,1.74039,1.74039,0,0,0,.25543-.93591,1.52894,1.52894,0,0,0-.49658-1.248,1.562,1.562,0,0,0-.96417-.29742,1.49058,1.49058,0,0,0-1.333.6098A2.0801,2.0801,0,0,0,10.33,9.96259v.01428H8.20367A3.39529,3.39529,0,0,1,9.37982,7.16913a3.80684,3.80684,0,0,1,2.45337-.79407,4.83031,4.83031,0,0,1,2.24054.49634A2.88658,2.88658,0,0,1,15.67664,9.66425ZM22.00006,12a10,10,0,1,1-10-10A10,10,0,0,1,22.00006,12Zm-2,0a8,8,0,1,0-8,8A8.00905,8.00905,0,0,0,20.00006,12ZM12,15.25a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,15.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.def6b3dd071c5e8156f2d38cf21dff3d.svg";
export { ForwardRef as ReactComponent };